import { render, staticRenderFns } from "./AssemblyPartner.vue?vue&type=template&id=fffa3b14&scoped=true&"
import script from "./AssemblyPartner.vue?vue&type=script&lang=js&"
export * from "./AssemblyPartner.vue?vue&type=script&lang=js&"
import style0 from "./AssemblyPartner.vue?vue&type=style&index=0&id=fffa3b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffa3b14",
  null
  
)

export default component.exports